import $ from "jquery";
import compile from "@bd-utils/handlerbars-helper";
import BD_Component from "@bd-core/bd-component";
import fb from "@bd-core/firebase";
import CONFIG from "@bd-core/config";
import { getCurrentPageId } from "@bd-stores/user-progress";
import CompletionPopup from "@bd-utils/completion-popup";
import {
    getPlayers,
    getRoomStartedAt,
    getRoomStatus,
    getTeamAnswers,
} from "@bd-stores/game-progress";
import {
    maybeUpdateRoomStatus,
    updateRoomAnswer,
    saveFinalRoomAnswers,
    removeRoomAnswer,
} from "@bd-core/firebase-actions";

export class RoomSwitchPuzzle extends BD_Component {
    constructor() {
        super();

        this.id = "switch_puzzle";
        this.templateID = "switch_puzzle-template";

        this.elms = {
            puzzleContent: "#switchPuzzle",
            puzzleOverlay: ".js-puzzle-popup",
            openPuzzle: ".js-switchPuzzle-open",
            closePuzzle: ".js-switchPuzzle-close",
            puzzleItem: ".js-puzzle-item",
            panelItem: ".js-panel-item",
            actions: ".js-actions",
            confirmation: "#initialSubmit",
            closeNotMatch: ".js-mismatch-close",
            answerMismatch: ".js-answer-mismatch",
            answerWaiting: ".js-answer-waiting",
            answerWrong: ".js-answer-wrong",
            background: ".js-screen-img",
            backgroundImage: ".screen__navigate",
            lightAnswer: ".js-sync-answer",
            resultFeedback: ".js-feedback",
            hintBtn: ".js-hint-btn",
            submitFingerprintBtn: ".js-submit-btn",
            playerCount: ".js-player-count",
            submitWrapper: ".js-submit-wrapper",
            hintItems: ".js-hints-item",
            hintTimerBox: ".js-hint-timer-box",
            hintTimer: ".js-hint-timer",
            hintCounter: ".js-hint-counter",
        };

        this._events = this.getEvents();

        this.fbEvents = [];

        this.completionPopup = new CompletionPopup();

        this.startX = 0;
        this.startY = 0;
        this.zoom = 100;
        this.hotspotSize = 21.5;
        this.isDown = false;
        this.hintInterval = null;
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: `${elms.openPuzzle}, ${elms.closePuzzle}`,
                handler: this.onTogglePuzzle,
            },
            {
                event: "click",
                selector: elms.submitFingerprintBtn,
                handler: this.submitFingerprint,
            },
        ];
    }

    beforeInit() {
        this.render();
        this.setGameState();
        const roomStatus = getRoomStatus(this.roomId);
        if (roomStatus !== "is-status-completed") this.listenScannedUsers();
    }

    getModifiedData() {
        const modified = { ...this._data };
        const hotspots = modified["hotspots"];
        const players = getPlayers();
        const onlinePlayers = players.filter((player) => player.isOnline);

        const hintHotspots = hotspots.filter(
            (hotspot) => hotspot["hotspot_type"] === "hint",
        );

        const hotspotCount = hintHotspots.length;
        const defaultValue = "50%";
        const _hints = this._data.hints.map((hint, i) => {
            return {
                ...hint,
                position_top:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_top
                        : defaultValue,
                position_left:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_left
                        : defaultValue,
            };
        });

        const modifiedData = {
            ...modified,
            hints: _hints,
            players: onlinePlayers,
        };

        return modifiedData;
    }

    render() {
        const modifiedData = this.getModifiedData();
        const isForcedOpenChallenge = modifiedData["force_open_challenge"];

        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, modifiedData);
        $(".app").html(html);

        if (isForcedOpenChallenge) {
            this.onForceOppenChallenge();
        }
    }

    onForceOppenChallenge() {
        const elms = this.elms;
        const $puzzleOverlay = $(elms.puzzleOverlay);
        const hasOpen = $puzzleOverlay.hasClass("is-open");
        const isOpened = !hasOpen;
        const blur = $(".app-blur");

        blur.toggleClass("is-blurred", isOpened);

        $puzzleOverlay.toggleClass("is-open", isOpened);
    }

    setGameState() {
        const roomID = this.roomId;
        const thisRoomStatus = getRoomStatus(roomID);

        const elms = this.elms;
        const $submitWrapper = $(elms.submitWrapper);
        const $submitBtn = $(elms.submitFingerprintBtn);
        const currentPlayerId = CONFIG.user.id;

        const possibleStatuses = [
            "is-status-open",
            "is-status-started",
            "is-status-completed",
        ];

        if (thisRoomStatus) {
            const $status = $(".js-room-status");
            $status.removeClass(possibleStatuses);
            $status.addClass(thisRoomStatus);
        }

        
        if(thisRoomStatus === "is-status-completed") {
            $submitWrapper.addClass("is-success-all");
            $submitBtn.addClass("is-success");
        } else {
            const tempRoomAnswers = getTeamAnswers(roomID);

            if (Object.keys(tempRoomAnswers).length) {
                const currentPlayerAnswer = tempRoomAnswers[currentPlayerId];
                
                if (currentPlayerAnswer) {
                    $submitBtn.addClass("is-waiting");
                }
            }
        }

        this.handleHintVisibility();
    }

    handleHintVisibility() {
        const elms = this.elms;
        const $hintItems = $(elms.hintItems);
        const hintCount = $hintItems.length;
        let currentHintIndex = 0;
        const $firstHint = $hintItems.first();
        let hintTimerToActive = Number($firstHint.attr("data-timer"));
        const roomStartedAt = getRoomStartedAt(this.roomId, CONFIG.user.id);
        if(!roomStartedAt) return;

        if(hintCount === 0) return;

        if(this.hintInterval) {
            clearInterval(this.hintInterval);
            this.hintInterval = null;
        }

        const checkHints = () => {
            const now = Date.now();
            const minutesPassed = Math.floor((now - roomStartedAt) / 60000); //convert ms to minutes
            // let hintActiveId = null;

            $hintItems.each(function (index) {
                const $this = $(this);
                const hintTimer = Number($this.attr("data-timer"));
                if(minutesPassed >= hintTimer) {
                    // $hintItems.addClass("hidden");
                    $this.removeClass("hidden");
                    // hintActiveId = $this.attr("data-id");
                    const $nextHint = $this.next();
                    hintTimerToActive = $nextHint.length ? Number($nextHint.attr("data-timer")) : 0;
                    currentHintIndex = index + 1;
                }
            });

            if(hintTimerToActive > 0) {
                const nextHintTimer = hintTimerToActive;
                const nextHintTimerInMs = (nextHintTimer * 60000 + roomStartedAt) - now;
                const minutesToNextHint = Math.floor(nextHintTimerInMs / 60000);
                const secondsToNextHint = Math.floor((nextHintTimerInMs % 60000) / 1000);
                const minutesTxt = minutesToNextHint < 10 ? `0${minutesToNextHint}` : minutesToNextHint;
                const secondsTxt = secondsToNextHint < 10 ? `0${secondsToNextHint}` : secondsToNextHint;
                const nextHintTimerText =  `${minutesTxt}:${secondsTxt}`;

                $(elms.hintTimer).text(nextHintTimerText);
            }

            const nextHintCounter = `${currentHintIndex}/${hintCount}`;
            $(elms.hintCounter).text(nextHintCounter);

            // if last hint, hide timer box and clear interval
            if(currentHintIndex === hintCount) {
                $(elms.hintTimerBox).addClass("hidden");
                clearInterval(this.hintInterval);
            }
        }

        // Run immediately on page load
        checkHints();

        // Run every seconds
        this.hintInterval = setInterval(checkHints, 1000);
    }

    // ============================== CUSTOM FUNCTION
    submitFingerprint(e) {
        const $this = $(e.currentTarget);
        const roomID = this.roomId;
        const currentPlayerId = CONFIG.user.id;
        const roomStatus = "is-status-started";

        if ($this.hasClass("is-waiting") || $this.hasClass("is-success")) {
            return false;
        }

        $this.addClass("is-waiting");
        updateRoomAnswer(roomID, {
            [currentPlayerId]: currentPlayerId,
        });

        maybeUpdateRoomStatus(roomID, roomStatus);
        this.returnToDefaultState();
    }

    returnToDefaultState() {
        const elms = this.elms;
        const roomID = this.roomId;
        const currentPlayerId = CONFIG.user.id;
        const isCompleted = this.isTheRoomFinish();
        const { timer } = this._data;
        const timerInMs = Number(timer) * 1000;

        if (isCompleted) {
            $(elms.submitFingerprintBtn).removeClass("is-failed");
            return;
        }

        setTimeout(() => {
            const isCompleted = this.isTheRoomFinish();

            $(elms.submitFingerprintBtn)
                .removeClass("is-waiting")
                .addClass("is-failed");

            if (!isCompleted) {
                $(elms.submitFingerprintBtn)
                    .removeClass("is-waiting")
                    .addClass("is-failed");
            }

            removeRoomAnswer(roomID, currentPlayerId);
        }, timerInMs);

        setTimeout(() => {
            $(elms.submitFingerprintBtn).removeClass("is-waiting is-failed");
        }, 5000);
    }

    handleCurrentPlayerAnswer(snapshot) {
        const elms = this.elms;
        const answers = snapshot.val();
        const totalAnswers = answers ? Object.keys(answers).length : 0;
        const $currentCount = $(elms.playerCount).find(".current-count");
        const $totalCount = $(elms.playerCount).find(".total-count");

        const players = getPlayers();
        const totalOnlinePlayers = players.filter((p) => p.isOnline).length;

        $currentCount.text(totalAnswers);
        $totalCount.text(totalOnlinePlayers);
    }

    checkAreAllPlayersClicked(answers) {
        const players = getPlayers();
        const totalOnlinePlayer = players.filter((p) => p.isOnline).length;

        if (answers === null) return false;

        const totalPlayerAnswer = Object.keys(answers).length;

        if (totalPlayerAnswer < totalOnlinePlayer) return false;

        return true;
    }

    /**
     * If current user hasn't answered anything, don't do anything
     * If all user already submit the answer, room completed
     *
     * That is only applied for user that are currently online, offline user
     * would be ignored
     *
     * @param {*} snapshot
     */
    scanUsersListener(snapshot) {
        const playersAnswer = snapshot.val();
        const completed = "is-status-completed";
        const roomID = getCurrentPageId();
        const hasBeenCompleted = getRoomStatus(roomID) === completed;
        const isAllClicked = this.checkAreAllPlayersClicked(playersAnswer);

        if (!isAllClicked) return;

        if (hasBeenCompleted) return;

        if (playersAnswer === null) return;

        this.handleAllPlayersClicked();

        setTimeout(() => {
            saveFinalRoomAnswers(roomID, playersAnswer);
            maybeUpdateRoomStatus(roomID, completed);
        }, 4000);
    }

    handleAllPlayersClicked() {
        const elms = this.elms;
        const $submitWrapper = $(elms.submitWrapper);
        const $submitBtn = $(elms.submitFingerprintBtn);

        $submitBtn.addClass("is-success");
        $submitWrapper.addClass("is-success-all");
    }

    onTogglePuzzle() {
        const elms = this.elms;
        const $puzzleOverlay = $(elms.puzzleOverlay);
        const hasOpen = $puzzleOverlay.hasClass("is-open");
        const isOpened = !hasOpen;
        const blur = $(".app-blur");

        blur.toggleClass("is-blurred", isOpened);

        $puzzleOverlay.toggleClass("is-open", isOpened);
    }

    /**
     * Callback to check whether the room is ready to finish
     */
    maybeReadyToFinish() {
        if (this.isTheRoomFinish()) return;

        const roomID = this.roomId;
        fb.get(`${fb.roomsPath}/${roomID}/answers`).then(
            this.scanUsersListener.bind(this),
        );
    }

    /**
     * Listener
     * @param {boolean} off turn on/off the event listener
     */
    listenScannedUsers(off = false) {
        const roomID = this.roomId;
        const path = `${fb.roomsPath}/${roomID}/answers`;
        const scanHandler = (data) => {
            this.handleCurrentPlayerAnswer(data);
            this.scanUsersListener(data);
        };
        const finishHandler = () => this.maybeReadyToFinish();

        if (off) {
            this.fbEvents.forEach((fn) => fn.call());
            this.fbEvents = [];
        } else {
            const ansListener = fb.onValue(path, scanHandler);
            const plyListerner = fb.onValue(fb.playersPath, finishHandler);

            this.fbEvents.push(ansListener);
            this.fbEvents.push(plyListerner);
        }
    }

    isTheRoomFinish() {
        return getRoomStatus(this.roomId) == "is-status-completed";
    }

    beforeDestroy() {
        this.listenScannedUsers(true);
        if(this.hintInterval) clearInterval(this.hintInterval);
    }
}
